import { LitElement, css, html, nothing, unsafeHTML } from '@lit'

class NovaBagMessage extends LitElement {
  static properties = {
    message: {
      type: String,
    }
  }

  connectedCallback() {
    super.connectedCallback()
  }

  render() {
    return html`
      <div class="dust-bag-message">
        ${this.message ? unsafeHTML(this.message) : nothing}
      </div>
    `
  }

  static styles = css`
    .dust-bag-message {
      border-top: 1px solid var(--nova-brand-grey-50);
      border-bottom: 1px solid var(--nova-brand-grey-50);
      padding: 16px 8px;
    }

    p {
      margin-top: 0;
      margin-bottom: 0;
    }

    p ~ p {
      margin-top: 6px;
    }

    a {
      color: currentColor;
    }

    strong {
      font-family: var(--nova-font-sans-medium);
      font-weight: 500;
    }

    @media screen and (min-width: 750px) {
      .dust-bag-message {
        padding-left: 15px;
        padding-right: 15px;
      }
    }
  `
}

window.customElements.define('nova-bag-message', NovaBagMessage)
